import { Injectable } from '@angular/core';

import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoticeConfidentialityService {

  constructor(
    private readonly _api: ApiService
  ) { }

  /**
   * Update SystemUser record when notice confidentiality is accepted.
   */
  public acceptNoticeConfidentiality$(): Observable<void> {
    return this._api.post$('noticeconfidentiality', '');
  }
}
